import { render, staticRenderFns } from "./OrderItemLinkDeleteForm.vue?vue&type=template&id=9ee58684"
import script from "./OrderItemLinkDeleteForm.vue?vue&type=script&lang=js"
export * from "./OrderItemLinkDeleteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports